export const ADD_BANK_DETAILS = "ADD_BANK_DETAILS";
export const ADD_BANK_DETAILS_SUCCESS = "ADD_BANK_DETAILS_SUCCESS";
export const ADD_BANK_DETAILS_FAILURE = "ADD_BANK_DETAILS_FAILURE";
export const EDIT_BANK_DETAILS = "EDIT_BANK_DETAILS";
export const EDIT_BANK_DETAILS_RESET = "EDIT_BANK_DETAILS_RESET";
export const EDIT_BANK_DETAILS_SUCCESS = "EDIT_BANK_DETAILS_SUCCESS";
export const EDIT_BANK_DETAILS_FAILURE = "EDIT_BANK_DETAILS_FAILURE";
